module.exports = __webpack_public_path__ + "static/media/icon-dollar.4197f1d9.png";